import axios from 'axios'
import {React , useState , useEffect } from 'react'
import Cards from "../Content/Cards"
import "../Pages/Trending_sty.css"
import CustomPagination from "../components/CustomPagination"
import Genres from "../components/Genres"
import useGenres from "../hooks/useGenres"

let res = 0;
const Movies = () => {

  const [page, setPage] = useState(1);
  const [content, setContent] = useState([]);
  const [numofpages, setNumOfPages] = useState();
  const [genres, setGenres] = useState([]);
  const [selectedGenres, setSelectedGenres] = useState([]);
  const genreforURL =  useGenres(selectedGenres);
  const fetchMovie = async () => {
    const {data} = await axios.get(
      `https://api.themoviedb.org/3/discover/movie?api_key=${process.env.REACT_APP_API_KEY}&language=en-US&sort_by=popularity.desc&include_adult=false&include_video=false&page=${page}&with_genres=${genreforURL}`
      )
      setContent(data.results);
      setNumOfPages(data.total_pages);
  }
  useEffect(() => {
    fetchMovie();
    // eslint-disable-next-line 
  }, [page,genreforURL])
  return (
    <>
      <span className = "pagetitle">Movies</span>
      <Genres
        Key = {res++}
        type = "movie"
        selectedGenres = {selectedGenres}
        setSelectedGenres = {setSelectedGenres}
        genres = {genres}
        setGenres = {setGenres}
        setPage = {setPage}
      />
      <div className = "Trend">{content&&content.map((val)=>{
       return(
       <Cards 
       key = {val.id} 
       id = {val.id} 
       poster = {val.poster_path} 
       title = {val.title || val.name} 
       date = {val.release_date || val.first_air_date}
       media_type = "movie"
       vote_average = {val.vote_average}
       />
       )
       })}</div>
       {numofpages>1&&<CustomPagination setPage = {setPage} numofPages = {numofpages}/>}
    </>
  )
}

export default Movies
